/**
 * @description Open share link in new window popup, instead of new tab (in which the time of edit)
 *
 * @see /resources/views/components/ui/sharing-panel.blade.php
 */
import {openAsWindow} from '../modules/windowOpener.js';

const activatedInstances = [];

/**
 * Listener when share link has being clicked
 * @param {Event} clickEvent
 */
let onLinkClicked = (clickEvent) => {
    /** @type {HTMLAnchorElement} */
    const anchor = clickEvent.currentTarget;
    const url = anchor.getAttribute('href');
    const target = anchor.getAttribute('target');

    // A touch screen opens the link as a plain tap, so the phone can hand it to the network's app.
    if (url && target === '_blank' && window.matchMedia('(pointer: fine)').matches) {
        clickEvent.preventDefault();

        openAsWindow(url);
    }

    anchor.dispatchEvent(new CustomEvent('dev:metric', {
        detail: {
            category: 'sharingPanel',
            action: 'click',
            type: anchor.title || 'Unknown button',
        },
        bubbles: true,
    }));
};

/**
 * Implement all the share link to open as a new window
 * as user click on it
 */
const openShareLinkAsNewWindow = () => {
    let shareLinks = [...document.querySelectorAll('.js-shareLink')];
    shareLinks.forEach((anchor) => {
        if (!activatedInstances.includes(anchor)) {
            anchor.addEventListener('click', onLinkClicked);
        }
    });
};

document.readyState === 'loading'
    ? new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, {once: true})).then(openShareLinkAsNewWindow)
    : openShareLinkAsNewWindow();
